import LinkSecondary from './LinkSecondary';

export default LinkSecondary;
